/** Avatar behavior modes for CSS / video-loop interviewer */
export const AvatarBehavior = Object.freeze({
  SPEAKING: 'speaking',
  LISTENING: 'listening',
  THINKING: 'thinking',
  IDLE: 'idle',
  COMPLETED: 'completed',
});

/** Expression PNG map (served from /public/bot/expressions) */
export const EXPRESSION_MAP = {
  introduction: '/bot/expressions/introduction.png',
  asking: '/bot/expressions/asking.png',
  listening: '/bot/expressions/listening.png?v=3',
  thinking: '/bot/expressions/thinking.png',
  closing: '/bot/expressions/closing.png',
  // Backward-compatibility aliases mapped to blue suit speaking pose:
  followup: '/bot/expressions/asking.png',
  behavioral: '/bot/expressions/asking.png',
};

export const INTERVIEW_BACKGROUND_COLOR = '#7f8bb3';

/**
 * Map interview UI state → avatar behavior + expression key.
 * Strictly uses the 5 official Blue Suit poses to maintain consistent wardrobe throughout the entire interview.
 */
export function resolveAvatarPresentation({
  raniSpeaking,
  showingClosingTTS,
  processingAnswer,
  waitingForAnswer,
  isRecording,
  questionType,
}) {
  if (showingClosingTTS) {
    return { behavior: AvatarBehavior.SPEAKING, expression: 'closing' };
  }
  if (raniSpeaking) {
    const qt = (questionType || '').toLowerCase();
    const expression = (qt.includes('intro') || qt.includes('warm')) ? 'introduction' : 'asking';
    return { behavior: AvatarBehavior.SPEAKING, expression };
  }
  if (processingAnswer) {
    return { behavior: AvatarBehavior.THINKING, expression: 'thinking' };
  }
  if (waitingForAnswer || isRecording) {
    return { behavior: AvatarBehavior.LISTENING, expression: 'listening' };
  }
  const qt = (questionType || '').toLowerCase();
  const idleExpression = (qt.includes('intro') || qt.includes('warm')) ? 'introduction' : 'listening';
  return { behavior: AvatarBehavior.IDLE, expression: idleExpression };
}
